<div class="pop-up__container">
  <app-pop-up-message *ngFor="let popUp of popUps" [popUp]="popUp"></app-pop-up-message>
</div>
